// extracted by mini-css-extract-plugin
export default {"container":"styles_container__U8oZJ","h1":"styles_h1__oxiz+","p":"styles_p__oeXcW","button":"styles_button__TXQ-w"};